import styles from './BlankRow.module.css';

export default function BlankRow() {
  return <div className={`${styles.blank_row}`}></div>;
}
